import moment from 'moment-timezone'

export const zones = {
  'UTC+00:00.0': 'Africa/Casablanca',
  'UTC+00:00.1': 'Etc/GMT',
  'UTC+00:00.2': 'Europe/London',
  'UTC+00:00.3': 'Atlantic/Reykjavik',
  'UTC+01:00.0': 'Europe/Berlin',
  'UTC+01:00.1': 'Europe/Budapest',
  'UTC+01:00.2': 'Europe/Paris',
  'UTC+01:00.3': 'Europe/Warsaw',
  'UTC+01:00.4': 'Africa/Tripoli',
  'UTC+01:00.5': 'Africa/Lagos',
  'UTC+01:00.6': 'Africa/Windhoek',
  'UTC+02:00.0': 'Europe/Bucharest',
  'UTC+02:00.1': 'Asia/Beirut',
  'UTC+02:00.2': 'Africa/Cairo',
  'UTC+02:00.3': 'Asia/Damascus',
  'UTC+02:00.4': 'Europe/Chisinau',
  'UTC+02:00.5': 'Africa/Johannesburg',
  'UTC+02:00.6': 'Europe/Kiev',
  'UTC+02:00.7': 'Europe/Istanbul',
  'UTC+02:00.8': 'Asia/Jerusalem',
  'UTC+03:00.0': 'Asia/Amman',
  'UTC+03:00.1': 'Asia/Baghdad',
  'UTC+03:00.2': 'Europe/Kaliningrad',
  'UTC+03:00.3': 'Asia/Riyadh',
  'UTC+03:00.4': 'Africa/Nairobi',
  'UTC+03:30.0': 'Asia/Tehran',
  'UTC+04:00.1': 'Asia/Dubai',
  'UTC+04:00.2': 'Asia/Baku',
  'UTC+04:00.3': 'Europe/Moscow',
  'UTC+04:00.4': 'Indian/Mauritius',
  'UTC+04:00.5': 'Asia/Tbilisi',
  'UTC+04:00.6': 'Asia/Yerevan',
  'UTC+04:30.0': 'Asia/Kabul',
  'UTC+05:00.0': 'Asia/Tashkent',
  'UTC+05:00.1': 'Asia/Karachi',
  'UTC+05:30.0': 'Asia/Calcutta',
  'UTC+05:30.1': 'Asia/Colombo',
  'UTC+05:45.0': 'Asia/Katmandu',
  'UTC+06:00.0': 'Asia/Almaty',
  'UTC+06:00.1': 'Asia/Dhaka',
  'UTC+06:00.2': 'Asia/Yekaterinburg',
  'UTC+06:30.0': 'Asia/Rangoon',
  'UTC+07:00.0': 'Asia/Bangkok',
  'UTC+07:00.1': 'Asia/Novosibirsk',
  'UTC+08:00.0': 'Asia/Shanghai',
  'UTC+08:00.1': 'Asia/Krasnoyarsk',
  'UTC+08:00.2': 'Asia/Singapore',
  'UTC+08:00.3': 'Australia/Perth',
  'UTC+08:00.4': 'Asia/Taipei',
  'UTC+08:00.5': 'Asia/Ulaanbaatar',
  'UTC+09:00.0': 'Asia/Irkutsk',
  'UTC+09:00.1': 'Asia/Tokyo',
  'UTC+09:00.2': 'Asia/Seoul',
  'UTC+09:30.0': 'Australia/Adelaide',
  'UTC+09:30.1': 'Australia/Darwin',
  'UTC+10:00.0': 'Australia/Brisbane',
  'UTC+10:00.1': 'Australia/Sydney',
  'UTC+10:00.2': 'Pacific/Port_Moresby',
  'UTC+10:00.3': 'Australia/Hobart',
  'UTC+10:00.4': 'Asia/Yakutsk',
  'UTC+11:00.0': 'Pacific/Guadalcanal',
  'UTC+11:00.1': 'Asia/Vladivostok',
  'UTC+12:00.0': 'Pacific/Auckland',
  'UTC+12:00.1': 'Etc/GMT-12',
  'UTC+12:00.2': 'Pacific/Fiji',
  'UTC+12:00.3': 'Asia/Magadan',
  'UTC+12:00.4': 'Asia/Kamchatka',
  'UTC+13:00.0': 'Pacific/Tongatapu',
  'UTC+13:00.1': 'Pacific/Apia',
  'UTC-01:00.0': 'Atlantic/Azores',
  'UTC-01:00.1': 'Atlantic/Cape_Verde',
  'UTC-02:00.0': 'Etc/GMT+2',
  'UTC-02:00.1': 'Etc/GMT+2',
  'UTC-03:00.0': 'America/Sao_Paulo',
  'UTC-03:00.1': 'America/Buenos_Aires',
  'UTC-03:00.2': 'America/Cayenne',
  'UTC-03:00.3': 'America/Godthab',
  'UTC-03:00.4': 'America/Montevideo',
  'UTC-03:00.5': 'America/Bahia',
  'UTC-03:30.0': 'America/St_Johns',
  'UTC-04:00.0': 'America/Asuncion',
  'UTC-04:00.1': 'America/Halifax',
  'UTC-04:00.2': 'America/Cuiaba',
  'UTC-04:00.3': 'America/La_Paz',
  'UTC-04:00.4': 'America/Santiago',
  'UTC-04:30.0': 'America/Caracas',
  'UTC-05:00.0': 'America/Bogota',
  'UTC-05:00.1': 'America/New_York',
  'UTC-05:00.2': 'America/Indianapolis',
  'UTC-06:00.0': 'America/Guatemala',
  'UTC-06:00.1': 'America/Chicago',
  'UTC-06:00.2': 'America/Mexico_City',
  'UTC-06:00.3': 'America/Regina',
  'UTC-07:00.0': 'America/Phoenix',
  'UTC-07:00.1': 'America/Chihuahua',
  'UTC-07:00.2': 'America/Denver',
  'UTC-08:00.0': 'America/Tijuana',
  'UTC-08:00.1': 'America/Los_Angeles',
  'UTC-09:00.0': 'America/Anchorage',
  'UTC-10:00.0': 'Pacific/Honolulu',
  'UTC-11:00.0': 'Etc/GMT+11',
  'UTC-12:00.0': 'Etc/GMT+12'
}

export const toLocalDate = (date, code) => {
  return new Date(date.getTime() - offsetFor(date, zones[code]))
}

export const fromLocalDate = (date, code) => {
  return new Date(date.getTime() + offsetFor(date, zones[code]))
}

export const offsetFor = (date, tz, toMilliseconds = 60000) => {
  return toMilliseconds * moment.tz.zone(tz).utcOffset(date.getTime())
}

export const handleFrom = (date, timeZone) => {
  return date
    ? fromLocalDate(firstSecOfDay(withoutOffset(date)), timeZone).toISOString()
    : ''
}

export const handleTo = (date, timeZone) => {
  return date
    ? fromLocalDate(lastSecOfDay(withoutOffset(date)), timeZone).toISOString()
    : ''
}

function lastSecOfDay(date) {
  const newDate = new Date(date.getTime())
  newDate.setUTCHours(23, 59, 59)
  return newDate
}

function firstSecOfDay(date) {
  const newDate = new Date(date.getTime())
  newDate.setUTCHours(0, 0, 0, 0)
  return newDate
}

/**
 * le date ritornate dal datepicker sono riferite alla timezone di sistema del client => rimozione offset
 *
 */
export function withoutOffset(date) {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
}

export function withoutOffsetToString(date) {
  return new Date(
    date.getTime() - date.getTimezoneOffset() * 60000
  ).toISOString()
}

/**
 * @param utcStringDate string UTC date
 * @param timeZoneCode string time zone
 * @param format moment-like date format
 * @param locale locale
 * @returns string formatted date according to time zone
 *
 */
export const fromUTCtoZoneFormatted = (
  utcStringDate,
  timeZoneCode,
  format = 'YYYY-MM-DD HH:mm',
  locale = 'en'
) => {
  return locale
    ? moment
        .tz(utcStringDate, zones[timeZoneCode])
        .locale(locale)
        .format(format)
    : moment.tz(utcStringDate, zones[timeZoneCode]).format(format)
}

export const dateFormat = (
  date,
  locale = 'en',
  format = 'YYYY-MM-DD HH:mm'
) => {
  return moment(date.toISOString()).locale(locale).format(format)
}

export const formatStringDatetime = (strdate, format) => {
  if (strdate) {
    switch (format) {
      case 'date':
        return strdate.split('T')[0]
      case 'time':
        return strdate.split('T')[1].slice(0, 5)
      default:
        // datetime
        return strdate.split('T')[0] + ' ' + strdate.split('T')[1].slice(0, 5)
    }
  }
}

export const jsDateTotringUTC = (date) => {
  return new Date(
    new Date(date).toLocaleString('en-US', {
      timeZone: zones['UTC+00:00.1']
    })
  )
}

export const getTimeObj = (date) => {
  const h = date.split('T')[1].split(':')[0]
  const m = date.split('T')[1].split(':')[1]
  return {
    hours: parseInt(h),
    minutes: parseInt(m)
  }
}
